// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"kQ-z","inlineTitle":"lQ-z","sponsoredAdsWrapper":"mQ-z","marketplaceRecosWrapper":"nQ-z"};